import Vue from 'vue'
import Router from 'vue-router'

import Video from '@/views/Video.vue'
import Education from '@/views/Education.vue'
import Consultation from '@/views/Consultation.vue'
import Login from '@/views/Login.vue'
import AddApply from '@/views/subPage/AddApply.vue'
import Record from '@/views/subPage/Record.vue'
import AddCourse from '@/views/subPage/AddCourse.vue'
import Arrange from '@/views/subPage/Arrange.vue'
import ArrangeRound from '@/views/subPage/arrangeRound.vue'
import SubWardRound from '@/views/subPage/SubWardRound.vue'
import VideoPlay from '@/views/subPage/VideoPlay.vue'
import Layout from '@/views/layout/index.vue'

Vue.use(Router)

export const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/index',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/Video',
        name: 'Video',
        component: Video
      },
      {
        path: '/VideoPlay',
        name: 'VideoPlay',
        component: VideoPlay
      },
      {
        path: '/AddApply',
        name: 'AddApply',
        component: AddApply
      },
      {
        path: '/Arrange',
        name: 'Arrange',
        component: Arrange
      },
      {
        path: '/ArrangeRound',
        name: 'ArrangeRound',
        component: ArrangeRound
      },
      {
        path: '/Record',
        name: 'Record',
        component: Record
      },
      {
        path: '/AddCourse',
        name: 'AddCourse',
        component: AddCourse
      },
      {
        path: '/SubWardRound',
        name: 'SubWardRound',
        component: SubWardRound
      },
      {
        path: '/WardRound',
        name: 'WardRound',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ './views/WardRound.vue')
      },
      {
        path: '/Education',
        name: 'Education',
        component: Education
      },
      {
        path: '/',
        name: 'Consultation',
        component: Consultation
      }
    ]
  }
]

export default new Router({
  // mode: 'history',
  routes: routes
})
